import { LegalDocument, type LegalSection } from '@/components/website/LegalDocument'
import { site } from '@/data/site'

const sections: LegalSection[] = [
  {
    heading: '1. Acceptance of Terms',
    body: (
      <p>
        By accessing or using the {site.name} website, booking an appointment, or using any of our online
        services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of
        these terms, please do not use the website or our online services.
      </p>
    ),
  },
  {
    heading: '2. Use of the Website',
    body: (
      <>
        <p>You agree to use this website only for lawful purposes and in a way that does not:</p>
        <ul>
          <li>infringe the rights of, or restrict or inhibit the use of, this website by any third party;</li>
          <li>introduce viruses, malware, or any other harmful material;</li>
          <li>attempt to gain unauthorised access to our systems, patient records, or portal accounts.</li>
        </ul>
      </>
    ),
  },
  {
    heading: '3. Appointments and Medical Services',
    body: (
      <p>
        Online appointment requests are a convenience only and are not confirmed until our staff contact you.
        Submitting a request does not guarantee a consultation time, doctor availability, or a particular
        treatment. All medical services are provided by qualified professionals following an in-person
        assessment.
      </p>
    ),
  },
  {
    heading: '4. Accurate Information',
    body: (
      <p>
        You are responsible for providing accurate, current, and complete information when booking an
        appointment, checking a report, or contacting us. We are not liable for delays, missed appointments, or
        incorrect reports caused by information you supply that is inaccurate or incomplete.
      </p>
    ),
  },
  {
    heading: '5. Medical Disclaimer',
    body: (
      <p>
        The content on this website is provided for general information only and does not constitute medical
        advice, diagnosis, or treatment. It is not a substitute for a consultation with a qualified healthcare
        professional. In an emergency, call our emergency line or visit the hospital immediately — do not rely
        on the website for urgent care.
      </p>
    ),
  },
  {
    heading: '6. Reports and Portal Access',
    body: (
      <p>
        Access to patient reports is protected by a one-time password (OTP) sent to the mobile number
        registered with the hospital. You must keep your receipt number, registered mobile number, and OTP
        confidential. You agree not to access, or attempt to access, the reports of any other person.
      </p>
    ),
  },
  {
    heading: '7. Fees and Cancellations',
    body: (
      <p>
        Applicable fees, charges, and cancellation or refund rules are explained at the hospital reception or
        on request. Any online estimates are indicative and may change after assessment by a doctor.
      </p>
    ),
  },
  {
    heading: '8. Intellectual Property',
    body: (
      <p>
        All text, graphics, logos, images, and other material on this website are the property of {site.name}
        or its licensors and are protected by applicable intellectual property laws. You may not reproduce,
        distribute, or use them without our prior written permission.
      </p>
    ),
  },
  {
    heading: '9. Third-Party Links',
    body: (
      <p>
        Our website may contain links to third-party websites. We do not control and are not responsible for
        the content, privacy practices, or availability of those websites. Accessing them is at your own risk.
      </p>
    ),
  },
  {
    heading: '10. Limitation of Liability',
    body: (
      <p>
        To the fullest extent permitted by law, {site.name} shall not be liable for any indirect, incidental,
        or consequential loss arising from your use of, or inability to use, this website or our online
        services.
      </p>
    ),
  },
  {
    heading: '11. Privacy',
    body: (
      <p>
        Our handling of your personal and health information is described in our Privacy Policy, which forms
        part of these Terms and Conditions.
      </p>
    ),
  },
  {
    heading: '12. Changes to These Terms',
    body: (
      <p>
        We may update these Terms and Conditions from time to time. Any changes take effect once published on
        this page. Continued use of the website after an update constitutes acceptance of the revised terms.
      </p>
    ),
  },
  {
    heading: '13. Governing Law',
    body: (
      <p>
        These terms are governed by the laws of Bangladesh. Any dispute arising from them is subject to the
        exclusive jurisdiction of the competent courts of Cumilla, Bangladesh.
      </p>
    ),
  },
  {
    heading: '14. Contact Us',
    body: (
      <p>
        If you have any questions about these Terms and Conditions, please contact us at{' '}
        <a href={`mailto:${site.email}`}>{site.email}</a> or call{' '}
        <a href={site.phoneHref}>{site.phone}</a>.
      </p>
    ),
  },
]

export function Terms() {
  return (
    <LegalDocument
      title="Terms and Conditions"
      subtitle="Please read these terms carefully before using our website and online services."
      lastUpdated="October 3, 2026"
      sections={sections}
    />
  )
}
